export class ModalModel {
  title: string = '';
  description: string = '';
  buttonLabel : string = '';
  imagePath: string = '';
  success: boolean = false;
  showModal: boolean = false;
}
